<template>
  <banners>
    <div
      class="header-text container-max mx-auto w-full px-4 pt-4 text-left md:px-10"
    >
      Users
    </div>
    <div class="-mt-3">
      <tabs
        :tab-options="tabOptions"
        :set-hash="setHash"
        :default-tab="defaultTab"
      />
    </div>
  </banners>
</template>

<script type="text/javascript">
import Banners from '@/components/Banners.vue';
import Tabs from '@/components/Tabs.vue';
import UsersIndex from '@/views/common/UsersIndex.vue';
import UsersInvitationsIndex from '@/views/common/UsersInvitationsIndex.vue';
import UserCompanyRequestsIndex from '@/components/carrier/UserCompanyRequestsIndex.vue';
import TabMixin from '@/mixins/tabs';
import { mapGetters } from 'vuex';

export default {
  name: 'Users Carrier Dashboard',
  components: {
    Banners,
    Tabs,
  },
  mixins: [TabMixin],
  data() {
    return {
      defaultTab: '',
    };
  },
  computed: {
    ...mapGetters({
      pendingRequestsCount: 'userCompanyRequests/pendingRequestsCount',
    }),
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    companyUsers() {
      return this.$store.state.users.companyUsers;
    },
    tabOptions() {
      const { scopes } = this.currentUser;
      const managerUserExists = (element) => element === 'manage_users';
      const managerUserScope = scopes.some(managerUserExists);

      // If the user include the manager_users in scope can visualize the users tab, otherwise not.
      if (!managerUserScope) {
        return [
          {
            title: 'invitations',
            component: UsersInvitationsIndex,
          },
          {
            title: 'requests',
            component: UserCompanyRequestsIndex,
            budgeNumber: this.pendingRequestsCount,
          },
        ];
      }

      return [
        {
          title: 'users',
          component: UsersIndex,
        },
        {
          title: 'invitations',
          component: UsersInvitationsIndex,
        },
        {
          title: 'requests',
          component: UserCompanyRequestsIndex,
          budgeNumber: this.pendingRequestsCount,
        },
      ];
    },
  },
  async created() {
    await this.$store.dispatch('userCompanyRequests/getUserCompanyRequests');
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
</style>
